const createTreeScrollManager = (scrollContainer) => {
    let scrollPosition = scrollContainer.scrollTop;

    const id = scrollContainer.dataset.persistTreeScroll;
    const key = `${id}_tree_scroll`;

    scrollContainer.addEventListener('scroll', (e) => {
        scrollPosition = scrollContainer.scrollTop
    })

    window.addEventListener('beforeunload', () => {
        sessionStorage.setItem(key, scrollPosition)
    })

    scrollContainer.scrollTop = +sessionStorage.getItem(key) || 0

}

export const launchTreeScrollManager = () => {
    document.querySelectorAll('[data-persist-tree-scroll]').forEach(createTreeScrollManager)
}